import React, { useState, useEffect, useRef } from 'react';
import useAnimationFrame from './useAnimationFrame';
import jsQR_Worker from './jsqr.worker';
import jsQR from 'jsqr';

function drawLine(context, begin, end, color) {
	context.beginPath();
	context.moveTo(begin.x, begin.y);
	context.lineTo(end.x, end.y);
	context.lineWidth = 4;
	context.strokeStyle = color;
	context.stroke();
}
const getDisplayStyle = (crop, isMonitorPortrait) => {
	return !isMonitorPortrait?
	crop?
	{width: '100%', top: '50%', transform: 'translateY(-50%)'}:
	{height: '100%', left: '50%', transform: 'translateX(-50%)'}:
	crop?
	{height: '100%', left: '50%', transform: 'translateX(-50%)'}:
	{width: '100%', top: '50%', transform: 'translateY(-50%)'};
}

const Display = ({stream, style, crop, onFrame}) => {
	const [isCrop, setIsCrop] = useState(crop);
	const [videoStyle, setVideoStyle] = useState(null);
	const video = useRef(null);
	const canvas = useRef(null);
	const overLayerCanvas = useRef(null);
	const webWorker = useRef(new jsQR_Worker());
	const qrCode = useRef(null);
	const decoded = useRef(true);

	
	// start Web Worker for Qr code detection only once
	useEffect(() => {
		const onFrameDecoded = (d) => {
			decoded.current = true;
			const code = d.data;
			if(!!code)
				return qrCode.current = code;
			qrCode.current = null;
		}
		console.log('creating');
		
		webWorker.current.onmessage = onFrameDecoded;
		return () => {
			webWorker.removeEventListener('message', onFrameDecoded);
		}
	}, []);
	useAnimationFrame(()=>{
		const context = canvas.current.getContext('2d');
		if (video.current.readyState === video.current.HAVE_ENOUGH_DATA) {
			canvas.current.height = video.current.videoHeight;
			canvas.current.width = video.current.videoWidth;		
			context.drawImage(video.current, 0, 0, canvas.current.width, canvas.current.height);
			const imageData = context.getImageData(0, 0, canvas.current.width, canvas.current.height);
//			const t = performance.now();
			// qrCode.current = jsQR(imageData.data, canvas.current.width, canvas.current.height)
//			console.log(performance.now() - t);
			if(decoded.current) {
				decoded.current = false;
				webWorker.current.postMessage( {
					data: imageData.data.buffer,
					width: canvas.current.width,
					height: canvas.current.height
				}, [imageData.data.buffer] );
			}
			{
				const canvas = overLayerCanvas.current;
				canvas.height = video.current.videoHeight;
				canvas.width = video.current.videoWidth;
				const context = canvas.getContext('2d');
				if (!!qrCode.current) {
					drawLine(context, qrCode.current.location.topLeftCorner, qrCode.current.location.topRightCorner, "#FF3B58");
					drawLine(context, qrCode.current.location.topRightCorner, qrCode.current.location.bottomRightCorner, "#FF3B58");
					drawLine(context, qrCode.current.location.bottomRightCorner, qrCode.current.location.bottomLeftCorner, "#FF3B58");
					drawLine(context, qrCode.current.location.bottomLeftCorner, qrCode.current.location.topLeftCorner, "#FF3B58");				
				} else {
					context.clearRect(0, 0, canvas.width, canvas.height);
				}
			}
		}		
	})
	
	useEffect(() => {
		if(!stream) return;
		let isMonitorPortrait = window.innerHeight > window.innerWidth ? true : false;
		setVideoStyle(getDisplayStyle(isCrop, isMonitorPortrait))
		video.current.srcObject = stream;
	}, [isCrop, stream]);
	return (
		<div style={Object.assign({position: 'absolute', width: '100%', height: '100%', overflow: 'hidden'}, style)}>
			<video ref={video} playsInline autoPlay style={Object.assign({}, videoStyle, { position: 'absolute' })}></video>
			<canvas ref={overLayerCanvas} style={Object.assign({}, videoStyle, { position: 'absolute' })}/>
			<canvas hidden ref={canvas}/>
			<span style={{position: "absolute"}} onClick={()=>setIsCrop(!isCrop)}>{isCrop?'uncrop':'crop'}</span>
		</div>
	);
}

export default Display;
